import React, { Fragment } from "react";
import { Skeleton } from "@material-ui/lab";
export const ActivitySkeleton = () => (React.createElement(Fragment, null,
    React.createElement(Skeleton, { variant: "text", height: 10 }),
    React.createElement(Skeleton, { variant: "text", height: 10 }),
    React.createElement(Skeleton, { variant: "text", height: 10 })));
